'use client'

import { useEffect, useState, useCallback } from 'react'

type Theme = 'light' | 'dark'

export default function ThemeToggle() {
  const [theme, setTheme] = useState<Theme | null>(null)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    const currentTheme = document.documentElement.getAttribute('data-theme') as Theme;
    if (currentTheme) setTheme(currentTheme)
  }, [])

  useEffect(() => {
    if (theme) {
      document.documentElement.setAttribute('data-theme', theme)
      try {
        localStorage.setItem('theme', theme)
      } catch { }
    }
  }, [theme])

  const toggle = useCallback(() => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'))
  }, [])

  if (!mounted) return <span className="text-xs text-muted-foreground">theme</span>

  return (
    <button
      onClick={toggle}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      className="text-xs text-muted-foreground hover:text-foreground transition-colors"
    >
      {theme === 'dark' ? 'light mode' : 'dark mode'}
    </button>
  )
}
